import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import LogoutDialog from "../common/LogoutDialog";
import styles from "./sidebar.module.scss";
import Sidebar_Logo from "Assets/wone_sidebar_logo.svg";
import { useAuth } from "providers/auth";
import { svgIcons } from "utility/svgIcons";
import CompanySidebarData, {
  SidebarGate,
} from "components/commons/Dashboard/CompanySidebarData";
import { useCompanyDashboardAccess } from "apps/company/api/rest/company-dashboard-access";
import { useTranslation } from "lib/i18n/use-translation";

const SideBar: React.FC = () => {
  //HOOKS
  const { t } = useTranslation(["admin", "common"]);
  const [logoutDialog, setLogoutDialog] = useState<boolean>(false);
  const { logout, learner, companyAdmin } = useAuth();
  const { enabled: companyDashboardEnabled } = useCompanyDashboardAccess();
  const { ProfileIcon, LogoutIcon, IconSwitchUser } = svgIcons();

  const gates: Record<SidebarGate, boolean> = {
    companyDashboard: companyDashboardEnabled === true,
  };

  const logOut = () => {
    setLogoutDialog(true);
  };
  const closeLogoutDialog = () => {
    setLogoutDialog(false);
  };
  const closeAfterYes = () => {
    logout();
    setLogoutDialog(false);
  };

  return (
    <div className={styles["sidebar-container"]}>
      <div className={styles["nav-top"]}>
        <Link to="/">
          <img
            src={Sidebar_Logo}
            className={styles["sidebar-logo"]}
            alt="walk-on-earth-logo"
            width="82px"
            height="20px"
          />
        </Link>

        <div className={styles["greetings-container"]}>
          <span>
            {t("admin:nav.welcome", { name: companyAdmin.firstName })}
          </span>
        </div>
      </div>

      <div className={styles["navigation-container"]}>
        <ul>
          {CompanySidebarData.map((item, index) => {
            if (item.gate && !gates[item.gate]) return null;
            const label = t(item.labelKey);
            return (
              <li key={index} className={styles[item.color]}>
                <NavLink
                  title={label}
                  className={({ isActive }) =>
                    isActive ? styles["activeClassName"] : undefined
                  }
                  to={item.path}
                >
                  {item.imgName}
                  <span>{label}</span>
                </NavLink>
                <ul>
                  <li>
                    <NavLink
                      title={item?.subNav?.title}
                      className={({ isActive }) =>
                        isActive ? styles["activeClassName"] : undefined
                      }
                      to={item?.subNav?.path}
                    >
                      {item?.subNav?.imgName}
                      <span>{item?.subNav?.title}</span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            );
          })}
        </ul>
      </div>
      <div className={styles["footer-nav-container"]}>
        <div className={styles["profile"]}>
          <NavLink
            className={({ isActive }) =>
              isActive ? styles["activeClassName"] : undefined
            }
            to="/client/admin-settings"
          >
            {ProfileIcon}
            <span>{t("admin:adminSettings.title")}</span>
          </NavLink>
        </div>

        {learner && (
          <div className={styles["switch-user"]}>
            <Link to="/">
              {IconSwitchUser}
              <span>{t("admin:nav.switchToMember")}</span>
            </Link>
          </div>
        )}

        <div className={styles["logout"]} onClick={logOut}>
          {LogoutIcon}
          <span>{t("common:action.logOut")}</span>
        </div>
      </div>
      {logoutDialog && (
        <LogoutDialog
          closeLogoutDialog={closeLogoutDialog}
          closeAfterYes={closeAfterYes}
        />
      )}
    </div>
  );
};
export default SideBar;
